import CampaignConversionPanel from './campaignConversionPanel.container';

export default CampaignConversionPanel;